// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/form/v1/form.proto" (package "c1.api.form.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Int64Rules } from "../../../../validate/validate";
import { RepeatedRules } from "../../../../validate/validate";
import { BoolRules } from "../../../../validate/validate";
import { StringRules } from "../../../../validate/validate";
/**
 * A form is a collection of fields to be filled out by a user
 *
 * @generated from protobuf message c1.api.form.v1.Form
 */
export interface Form {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 3
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 4
     */
    description: string;
    /**
     * @generated from protobuf field: repeated c1.api.form.v1.Field fields = 5
     */
    fields: Field[];
    /**
     * @generated from protobuf field: repeated c1.api.form.v1.FieldRelationship field_relationships = 6
     */
    fieldRelationships: FieldRelationship[];
    /**
     * @generated from protobuf field: repeated c1.api.form.v1.FieldGroup field_groups = 7
     */
    fieldGroups: FieldGroup[];
}
/**
 * A field is a single input meant to collect a piece of data from a user
 *
 * @generated from protobuf message c1.api.form.v1.Field
 */
export interface Field {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string; // Must be unique across all Fields in a Form, probably auto-generated in UI
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string; // AKA "label"
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string; // AKA "helper_text"
    /**
     * @generated from protobuf field: bool required = 4
     */
    required: boolean;
    /**
     * The type of data represented by the value of this field
     *
     * @generated from protobuf oneof: type
     */
    type: {
        oneofKind: "stringField";
        /**
         * @generated from protobuf field: c1.api.form.v1.StringField string_field = 100
         */
        stringField: StringField;
    } | {
        oneofKind: "boolField";
        /**
         * @generated from protobuf field: c1.api.form.v1.BoolField bool_field = 101
         */
        boolField: BoolField;
    } | {
        oneofKind: "stringSliceField";
        /**
         * @generated from protobuf field: c1.api.form.v1.StringSliceField string_slice_field = 102
         */
        stringSliceField: StringSliceField;
    } | {
        oneofKind: "int64Field";
        /**
         * @generated from protobuf field: c1.api.form.v1.Int64Field int64_field = 103
         */
        int64Field: Int64Field;
    } | {
        oneofKind: "fileField";
        /**
         * @generated from protobuf field: c1.api.form.v1.FileField file_field = 104
         */
        fileField: FileField;
    } | {
        oneofKind: "oauth2Field";
        /**
         * @generated from protobuf field: c1.api.form.v1.Oauth2Field oauth2_field = 105
         */
        oauth2Field: Oauth2Field;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf oneof: provider_config
     */
    providerConfig: {
        oneofKind: "userConfig";
        /**
         * @generated from protobuf field: c1.api.form.v1.UserProviderConfig user_config = 200
         */
        userConfig: UserProviderConfig;
    } | {
        oneofKind: "adminConfig";
        /**
         * @generated from protobuf field: c1.api.form.v1.AdminProviderConfig admin_config = 201
         */
        adminConfig: AdminProviderConfig;
    } | {
        oneofKind: "sharedConfig";
        /**
         * @generated from protobuf field: c1.api.form.v1.SharedProviderConfig shared_config = 202
         */
        sharedConfig: SharedProviderConfig;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.form.v1.UserProviderConfig
 */
export interface UserProviderConfig {
    /**
     * @generated from protobuf field: string input_transformation_cel = 1
     */
    inputTransformationCel: string;
}
/**
 * @generated from protobuf message c1.api.form.v1.AdminProviderConfig
 */
export interface AdminProviderConfig {
    /**
     * @generated from protobuf field: string default_value_cel = 1
     */
    defaultValueCel: string;
    /**
     * @generated from protobuf field: bool show_to_user = 2
     */
    showToUser: boolean;
}
/**
 * @generated from protobuf message c1.api.form.v1.SharedProviderConfig
 */
export interface SharedProviderConfig {
    /**
     * @generated from protobuf field: string default_value_cel = 1
     */
    defaultValueCel: string;
    /**
     * @generated from protobuf field: bool lock_default_values = 2
     */
    lockDefaultValues: boolean;
    /**
     * @generated from protobuf field: string input_transformation_cel = 3
     */
    inputTransformationCel: string;
}
/**
 * @generated from protobuf message c1.api.form.v1.StringField
 */
export interface StringField {
    /**
     * @generated from protobuf field: string default_value = 1
     */
    defaultValue: string;
    /**
     * @generated from protobuf field: optional validate.StringRules rules = 2
     */
    rules?: StringRules;
    /**
     * @generated from protobuf field: string placeholder = 3
     */
    placeholder: string;
    /**
     * "View" is generally how the field is displayed - either a plain text field,
     * or with a picker, as a ***** "password" field, etc
     *
     * @generated from protobuf oneof: view
     */
    view: {
        oneofKind: "textField";
        /**
         * @generated from protobuf field: c1.api.form.v1.TextField text_field = 100
         */
        textField: TextField;
    } | {
        oneofKind: "passwordField";
        /**
         * @generated from protobuf field: c1.api.form.v1.PasswordField password_field = 101
         */
        passwordField: PasswordField;
    } | {
        oneofKind: "selectField";
        /**
         * @generated from protobuf field: c1.api.form.v1.SelectField select_field = 104
         */
        selectField: SelectField;
    } | {
        oneofKind: "pickerField";
        /**
         * @generated from protobuf field: c1.api.form.v1.PickerField picker_field = 103
         */
        pickerField: PickerField;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.form.v1.TextField
 */
export interface TextField {
    /**
     * @generated from protobuf field: bool multiline = 1
     */
    multiline: boolean;
}
/**
 * @generated from protobuf message c1.api.form.v1.PasswordField
 */
export interface PasswordField {
}
/**
 * @generated from protobuf message c1.api.form.v1.Oauth2Field
 */
export interface Oauth2Field {
    /**
     * @generated from protobuf oneof: view
     */
    view: {
        oneofKind: "oauth2FieldView";
        /**
         * @generated from protobuf field: c1.api.form.v1.Oauth2FieldView oauth2_field_view = 100
         */
        oauth2FieldView: Oauth2FieldView;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.form.v1.Oauth2FieldView
 */
export interface Oauth2FieldView {
}
/**
 * @generated from protobuf message c1.api.form.v1.BoolField
 */
export interface BoolField {
    /**
     * @generated from protobuf field: bool default_value = 1
     */
    defaultValue: boolean;
    /**
     * @generated from protobuf field: optional validate.BoolRules rules = 2
     */
    rules?: BoolRules;
    /**
     * @generated from protobuf oneof: view
     */
    view: {
        oneofKind: "checkboxField";
        /**
         * @generated from protobuf field: c1.api.form.v1.CheckboxField checkbox_field = 100
         */
        checkboxField: CheckboxField;
    } | {
        oneofKind: "toggleField";
        /**
         * @generated from protobuf field: c1.api.form.v1.ToggleField toggle_field = 101
         */
        toggleField: ToggleField;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.form.v1.CheckboxField
 */
export interface CheckboxField {
}
/**
 * @generated from protobuf message c1.api.form.v1.ToggleField
 */
export interface ToggleField {
}
/**
 * @generated from protobuf message c1.api.form.v1.StringSliceField
 */
export interface StringSliceField {
    /**
     * @generated from protobuf field: repeated string default_values = 1
     */
    defaultValues: string[];
    /**
     * @generated from protobuf field: string placeholder = 3
     */
    placeholder: string;
    /**
     * @generated from protobuf field: optional validate.RepeatedRules rules = 4
     */
    rules?: RepeatedRules;
    /**
     * @generated from protobuf oneof: view
     */
    view: {
        oneofKind: "chipsField";
        /**
         * @generated from protobuf field: c1.api.form.v1.ChipsField chips_field = 100
         */
        chipsField: ChipsField;
    } | {
        oneofKind: "pickerField";
        /**
         * @generated from protobuf field: c1.api.form.v1.PickerField picker_field = 102
         */
        pickerField: PickerField;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.form.v1.SelectField
 */
export interface SelectField {
    /**
     * @generated from protobuf field: repeated c1.api.form.v1.SelectOption options = 2
     */
    options: SelectOption[];
    /**
     * @generated from protobuf field: c1.api.form.v1.SelectField.SelectType type = 3
     */
    type: SelectField_SelectType;
}
/**
 * @generated from protobuf enum c1.api.form.v1.SelectField.SelectType
 */
export enum SelectField_SelectType {
    /**
     * @generated from protobuf enum value: SELECT_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: SELECT_TYPE_DROPDOWN = 1;
     */
    DROPDOWN = 1,
    /**
     * @generated from protobuf enum value: SELECT_TYPE_RADIO = 2;
     */
    RADIO = 2,
    /**
     * @generated from protobuf enum value: SELECT_TYPE_BUTTONS = 3;
     */
    BUTTONS = 3
}
/**
 * @generated from protobuf message c1.api.form.v1.SelectOption
 */
export interface SelectOption {
    /**
     * @generated from protobuf field: string display_name = 1
     */
    displayName: string;
    /**
     * @generated from protobuf field: string value = 2
     */
    value: string;
    /**
     * Used for type BUTTONS
     *
     * @generated from protobuf field: string description = 3
     */
    description: string;
}
/**
 * @generated from protobuf message c1.api.form.v1.ChipsField
 */
export interface ChipsField {
}
/**
 * @generated from protobuf message c1.api.form.v1.PickerField
 */
export interface PickerField {
    /**
     * @generated from protobuf oneof: type
     */
    type: {
        oneofKind: "appUserPicker";
        /**
         * @generated from protobuf field: c1.api.form.v1.AppUserFilter app_user_picker = 100
         */
        appUserPicker: AppUserFilter;
    } | {
        oneofKind: "resourcePicker";
        /**
         * @generated from protobuf field: c1.api.form.v1.AppResourceFilter resource_picker = 101
         */
        resourcePicker: AppResourceFilter;
    } | {
        oneofKind: "c1UserPicker";
        /**
         * C1UserFilter is used to select ConductorOne users (not app users/accounts).
         *
         * @generated from protobuf field: c1.api.form.v1.C1UserFilter c1_user_picker = 102
         */
        c1UserPicker: C1UserFilter;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.form.v1.AppUserFilter
 */
export interface AppUserFilter {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.form.v1.AppResourceFilter
 */
export interface AppResourceFilter {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 2
     */
    resourceTypeId: string;
}
/**
 * C1UserFilter is used to configure a picker for selecting ConductorOne users.
 * This is distinct from AppUserFilter which selects accounts within a connected app.
 *
 * @generated from protobuf message c1.api.form.v1.C1UserFilter
 */
export interface C1UserFilter {
}
/**
 * @generated from protobuf message c1.api.form.v1.Int64Field
 */
export interface Int64Field {
    /**
     * @generated from protobuf field: optional int64 default_value = 1
     */
    defaultValue?: number;
    /**
     * @generated from protobuf field: optional validate.Int64Rules rules = 2
     */
    rules?: Int64Rules;
    /**
     * @generated from protobuf field: string placeholder = 3
     */
    placeholder: string;
    /**
     * @generated from protobuf oneof: view
     */
    view: {
        oneofKind: "numberField";
        /**
         * @generated from protobuf field: c1.api.form.v1.NumberField number_field = 100
         */
        numberField: NumberField;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.form.v1.NumberField
 */
export interface NumberField {
    /**
     * @generated from protobuf field: int64 min_value = 1
     */
    minValue: number;
    /**
     * @generated from protobuf field: int64 max_value = 2
     */
    maxValue: number;
    /**
     * @generated from protobuf field: int64 step = 3
     */
    step: number;
}
/**
 * @generated from protobuf message c1.api.form.v1.FileField
 */
export interface FileField {
    /**
     * @generated from protobuf field: repeated string accepted_file_types = 1
     */
    acceptedFileTypes: string[]; // MIME types or file extensions, for html input 'accept' attribute
    /**
     * @generated from protobuf field: optional int64 max_file_size = 2
     */
    maxFileSize?: number;
    /**
     * @generated from protobuf oneof: view
     */
    view: {
        oneofKind: "fileInputField";
        /**
         * @generated from protobuf field: c1.api.form.v1.FileInputField file_input_field = 100
         */
        fileInputField: FileInputField;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.form.v1.FileInputField
 */
export interface FileInputField {
}
/**
 * FieldRelationships can be used during form validation, or they can represent
 * information that is necessary to when it comes to visually rendering the form
 *
 * @generated from protobuf message c1.api.form.v1.FieldRelationship
 */
export interface FieldRelationship {
    /**
     * The names of the fields that share this relationship
     *
     * @generated from protobuf field: repeated string field_names = 1
     */
    fieldNames: string[];
    /**
     * @generated from protobuf oneof: kind
     */
    kind: {
        oneofKind: "requiredTogether";
        /**
         * All or none of field_names must be filled out
         *
         * @generated from protobuf field: c1.api.form.v1.RequiredTogether required_together = 100
         */
        requiredTogether: RequiredTogether;
    } | {
        oneofKind: "atLeastOne";
        /**
         * At least one of field_names must be filled out
         *
         * @generated from protobuf field: c1.api.form.v1.AtLeastOne at_least_one = 101
         */
        atLeastOne: AtLeastOne;
    } | {
        oneofKind: "mutuallyExclusive";
        /**
         * All field_names in this group are mutually exclusive with one another
         *
         * @generated from protobuf field: c1.api.form.v1.MutuallyExclusive mutually_exclusive = 102
         */
        mutuallyExclusive: MutuallyExclusive;
    } | {
        oneofKind: "dependentOn";
        /**
         * Fields in field_names are only valid if dependency_field_names are present
         *
         * @generated from protobuf field: c1.api.form.v1.DependentOn dependent_on = 103
         */
        dependentOn: DependentOn;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.form.v1.RequiredTogether
 */
export interface RequiredTogether {
}
/**
 * @generated from protobuf message c1.api.form.v1.AtLeastOne
 */
export interface AtLeastOne {
}
/**
 * @generated from protobuf message c1.api.form.v1.MutuallyExclusive
 */
export interface MutuallyExclusive {
}
/**
 * DependentOn means the fields in field_names are only valid if all fields
 * in dependency_field_names are also present
 *
 * @generated from protobuf message c1.api.form.v1.DependentOn
 */
export interface DependentOn {
    /**
     * The fields that must be present for the primary field_names to be valid
     *
     * @generated from protobuf field: repeated string dependency_field_names = 1
     */
    dependencyFieldNames: string[];
}
/**
 * @generated from protobuf message c1.api.form.v1.FieldGroup
 */
export interface FieldGroup {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string; // Unique ID.
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * @generated from protobuf field: string help_text = 3
     */
    helpText: string;
    /**
     * @generated from protobuf field: repeated string fields = 4
     */
    fields: string[];
    /**
     * @generated from protobuf field: bool default = 5
     */
    default: boolean;
}
/**
 * FormSchema represents a form template that can be used to create forms
 *
 * @generated from protobuf message c1.api.form.v1.FormSchema
 */
export interface FormSchema {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * @generated from protobuf field: c1.api.form.v1.Form form = 3
     */
    form?: Form;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 6
     */
    deletedAt?: Timestamp;
    /**
     * Indicates the usage context for this form schema.
     *
     * @generated from protobuf field: c1.api.form.v1.FormSchemaUsageContext usage_context = 7
     */
    usageContext: FormSchemaUsageContext;
}
/**
 * FormSchemaRef is a reference to a FormSchema
 *
 * @generated from protobuf message c1.api.form.v1.FormSchemaRef
 */
export interface FormSchemaRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * Request/Response messages for FormSchemaService
 *
 * @generated from protobuf message c1.api.form.v1.FormSchemaServiceCreateRequest
 */
export interface FormSchemaServiceCreateRequest {
    /**
     * @generated from protobuf field: c1.api.form.v1.Form form = 1
     */
    form?: Form;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * Indicates the usage context for this form schema.
     *
     * @generated from protobuf field: c1.api.form.v1.FormSchemaUsageContext usage_context = 3
     */
    usageContext: FormSchemaUsageContext;
}
/**
 * @generated from protobuf message c1.api.form.v1.FormSchemaServiceCreateResponse
 */
export interface FormSchemaServiceCreateResponse {
    /**
     * @generated from protobuf field: c1.api.form.v1.FormSchema form_schema = 1
     */
    formSchema?: FormSchema;
}
/**
 * @generated from protobuf message c1.api.form.v1.FormSchemaServiceGetRequest
 */
export interface FormSchemaServiceGetRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.form.v1.FormSchemaServiceGetResponse
 */
export interface FormSchemaServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.form.v1.FormSchema form_schema = 1
     */
    formSchema?: FormSchema;
}
/**
 * @generated from protobuf message c1.api.form.v1.FormSchemaServiceListRequest
 */
export interface FormSchemaServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.form.v1.FormSchemaRef refs = 3
     */
    refs: FormSchemaRef[];
}
/**
 * @generated from protobuf message c1.api.form.v1.FormSchemaServiceListResponse
 */
export interface FormSchemaServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.form.v1.FormSchema form_schemas = 1
     */
    formSchemas: FormSchema[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.form.v1.FormSchemaServiceUpdateRequest
 */
export interface FormSchemaServiceUpdateRequest {
    /**
     * @generated from protobuf field: c1.api.form.v1.FormSchema form_schema = 1
     */
    formSchema?: FormSchema;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.form.v1.FormSchemaServiceUpdateResponse
 */
export interface FormSchemaServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.form.v1.FormSchema form_schema = 1
     */
    formSchema?: FormSchema;
}
/**
 * @generated from protobuf message c1.api.form.v1.FormSchemaServiceDeleteRequest
 */
export interface FormSchemaServiceDeleteRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.form.v1.FormSchemaServiceDeleteResponse
 */
export interface FormSchemaServiceDeleteResponse {
}
/**
 * @generated from protobuf message c1.api.form.v1.FormSchemaServiceSearchRequest
 */
export interface FormSchemaServiceSearchRequest {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * Filter by usage context types.
     *
     * @generated from protobuf field: repeated c1.api.form.v1.FormSchemaUsageContext usage_contexts = 4
     */
    usageContexts: FormSchemaUsageContext[];
}
/**
 * @generated from protobuf message c1.api.form.v1.FormSchemaServiceSearchResponse
 */
export interface FormSchemaServiceSearchResponse {
    /**
     * Deprecated: Use list instead.
     *
     * @deprecated
     * @generated from protobuf field: repeated c1.api.form.v1.FormSchema form_schemas = 1 [deprecated = true]
     */
    formSchemas: FormSchema[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.form.v1.FormSchema list = 3
     */
    list: FormSchema[];
}
/**
 * Indicates the usage context for a FormSchema.
 *
 * @generated from protobuf enum c1.api.form.v1.FormSchemaUsageContext
 */
export enum FormSchemaUsageContext {
    /**
     * @generated from protobuf enum value: FORM_SCHEMA_USAGE_CONTEXT_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Used in automations.
     *
     * @generated from protobuf enum value: FORM_SCHEMA_USAGE_CONTEXT_AUTOMATION = 1;
     */
    AUTOMATION = 1,
    /**
     * Used for resource actions.
     *
     * @generated from protobuf enum value: FORM_SCHEMA_USAGE_CONTEXT_RESOURCE_ACTION = 2;
     */
    RESOURCE_ACTION = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class Form$Type extends MessageType<Form> {
    constructor() {
        super("c1.api.form.v1.Form", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Field },
            { no: 6, name: "field_relationships", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FieldRelationship },
            { no: 7, name: "field_groups", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FieldGroup }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Request_Schema" } }] } });
    }
    create(value?: PartialMessage<Form>): Form {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        message.description = "";
        message.fields = [];
        message.fieldRelationships = [];
        message.fieldGroups = [];
        if (value !== undefined)
            reflectionMergePartial<Form>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Form): Form {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string display_name */ 3:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                case /* repeated c1.api.form.v1.Field fields */ 5:
                    message.fields.push(Field.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.form.v1.FieldRelationship field_relationships */ 6:
                    message.fieldRelationships.push(FieldRelationship.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.form.v1.FieldGroup field_groups */ 7:
                    message.fieldGroups.push(FieldGroup.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Form, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string display_name = 3; */
        if (message.displayName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.displayName);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* repeated c1.api.form.v1.Field fields = 5; */
        for (let i = 0; i < message.fields.length; i++)
            Field.internalBinaryWrite(message.fields[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.form.v1.FieldRelationship field_relationships = 6; */
        for (let i = 0; i < message.fieldRelationships.length; i++)
            FieldRelationship.internalBinaryWrite(message.fieldRelationships[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.form.v1.FieldGroup field_groups = 7; */
        for (let i = 0; i < message.fieldGroups.length; i++)
            FieldGroup.internalBinaryWrite(message.fieldGroups[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.Form
 */
export const Form = new Form$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Field$Type extends MessageType<Field> {
    constructor() {
        super("c1.api.form.v1.Field", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "required", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 100, name: "string_field", kind: "message", oneof: "type", T: () => StringField },
            { no: 101, name: "bool_field", kind: "message", oneof: "type", T: () => BoolField },
            { no: 102, name: "string_slice_field", kind: "message", oneof: "type", T: () => StringSliceField },
            { no: 103, name: "int64_field", kind: "message", oneof: "type", T: () => Int64Field },
            { no: 104, name: "file_field", kind: "message", oneof: "type", T: () => FileField },
            { no: 105, name: "oauth2_field", kind: "message", oneof: "type", T: () => Oauth2Field },
            { no: 200, name: "user_config", kind: "message", oneof: "providerConfig", T: () => UserProviderConfig },
            { no: 201, name: "admin_config", kind: "message", oneof: "providerConfig", T: () => AdminProviderConfig },
            { no: 202, name: "shared_config", kind: "message", oneof: "providerConfig", T: () => SharedProviderConfig }
        ]);
    }
    create(value?: PartialMessage<Field>): Field {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.displayName = "";
        message.description = "";
        message.required = false;
        message.type = { oneofKind: undefined };
        message.providerConfig = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<Field>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Field): Field {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* bool required */ 4:
                    message.required = reader.bool();
                    break;
                case /* c1.api.form.v1.StringField string_field */ 100:
                    message.type = {
                        oneofKind: "stringField",
                        stringField: StringField.internalBinaryRead(reader, reader.uint32(), options, (message.type as any).stringField)
                    };
                    break;
                case /* c1.api.form.v1.BoolField bool_field */ 101:
                    message.type = {
                        oneofKind: "boolField",
                        boolField: BoolField.internalBinaryRead(reader, reader.uint32(), options, (message.type as any).boolField)
                    };
                    break;
                case /* c1.api.form.v1.StringSliceField string_slice_field */ 102:
                    message.type = {
                        oneofKind: "stringSliceField",
                        stringSliceField: StringSliceField.internalBinaryRead(reader, reader.uint32(), options, (message.type as any).stringSliceField)
                    };
                    break;
                case /* c1.api.form.v1.Int64Field int64_field */ 103:
                    message.type = {
                        oneofKind: "int64Field",
                        int64Field: Int64Field.internalBinaryRead(reader, reader.uint32(), options, (message.type as any).int64Field)
                    };
                    break;
                case /* c1.api.form.v1.FileField file_field */ 104:
                    message.type = {
                        oneofKind: "fileField",
                        fileField: FileField.internalBinaryRead(reader, reader.uint32(), options, (message.type as any).fileField)
                    };
                    break;
                case /* c1.api.form.v1.Oauth2Field oauth2_field */ 105:
                    message.type = {
                        oneofKind: "oauth2Field",
                        oauth2Field: Oauth2Field.internalBinaryRead(reader, reader.uint32(), options, (message.type as any).oauth2Field)
                    };
                    break;
                case /* c1.api.form.v1.UserProviderConfig user_config */ 200:
                    message.providerConfig = {
                        oneofKind: "userConfig",
                        userConfig: UserProviderConfig.internalBinaryRead(reader, reader.uint32(), options, (message.providerConfig as any).userConfig)
                    };
                    break;
                case /* c1.api.form.v1.AdminProviderConfig admin_config */ 201:
                    message.providerConfig = {
                        oneofKind: "adminConfig",
                        adminConfig: AdminProviderConfig.internalBinaryRead(reader, reader.uint32(), options, (message.providerConfig as any).adminConfig)
                    };
                    break;
                case /* c1.api.form.v1.SharedProviderConfig shared_config */ 202:
                    message.providerConfig = {
                        oneofKind: "sharedConfig",
                        sharedConfig: SharedProviderConfig.internalBinaryRead(reader, reader.uint32(), options, (message.providerConfig as any).sharedConfig)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Field, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* bool required = 4; */
        if (message.required !== false)
            writer.tag(4, WireType.Varint).bool(message.required);
        /* c1.api.form.v1.StringField string_field = 100; */
        if (message.type.oneofKind === "stringField")
            StringField.internalBinaryWrite(message.type.stringField, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.form.v1.BoolField bool_field = 101; */
        if (message.type.oneofKind === "boolField")
            BoolField.internalBinaryWrite(message.type.boolField, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.form.v1.StringSliceField string_slice_field = 102; */
        if (message.type.oneofKind === "stringSliceField")
            StringSliceField.internalBinaryWrite(message.type.stringSliceField, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.form.v1.Int64Field int64_field = 103; */
        if (message.type.oneofKind === "int64Field")
            Int64Field.internalBinaryWrite(message.type.int64Field, writer.tag(103, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.form.v1.FileField file_field = 104; */
        if (message.type.oneofKind === "fileField")
            FileField.internalBinaryWrite(message.type.fileField, writer.tag(104, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.form.v1.Oauth2Field oauth2_field = 105; */
        if (message.type.oneofKind === "oauth2Field")
            Oauth2Field.internalBinaryWrite(message.type.oauth2Field, writer.tag(105, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.form.v1.UserProviderConfig user_config = 200; */
        if (message.providerConfig.oneofKind === "userConfig")
            UserProviderConfig.internalBinaryWrite(message.providerConfig.userConfig, writer.tag(200, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.form.v1.AdminProviderConfig admin_config = 201; */
        if (message.providerConfig.oneofKind === "adminConfig")
            AdminProviderConfig.internalBinaryWrite(message.providerConfig.adminConfig, writer.tag(201, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.form.v1.SharedProviderConfig shared_config = 202; */
        if (message.providerConfig.oneofKind === "sharedConfig")
            SharedProviderConfig.internalBinaryWrite(message.providerConfig.sharedConfig, writer.tag(202, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.Field
 */
export const Field = new Field$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserProviderConfig$Type extends MessageType<UserProviderConfig> {
    constructor() {
        super("c1.api.form.v1.UserProviderConfig", [
            { no: 1, name: "input_transformation_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UserProviderConfig>): UserProviderConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.inputTransformationCel = "";
        if (value !== undefined)
            reflectionMergePartial<UserProviderConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserProviderConfig): UserProviderConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string input_transformation_cel */ 1:
                    message.inputTransformationCel = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserProviderConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string input_transformation_cel = 1; */
        if (message.inputTransformationCel !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.inputTransformationCel);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.UserProviderConfig
 */
export const UserProviderConfig = new UserProviderConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdminProviderConfig$Type extends MessageType<AdminProviderConfig> {
    constructor() {
        super("c1.api.form.v1.AdminProviderConfig", [
            { no: 1, name: "default_value_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "show_to_user", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AdminProviderConfig>): AdminProviderConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.defaultValueCel = "";
        message.showToUser = false;
        if (value !== undefined)
            reflectionMergePartial<AdminProviderConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AdminProviderConfig): AdminProviderConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string default_value_cel */ 1:
                    message.defaultValueCel = reader.string();
                    break;
                case /* bool show_to_user */ 2:
                    message.showToUser = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AdminProviderConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string default_value_cel = 1; */
        if (message.defaultValueCel !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.defaultValueCel);
        /* bool show_to_user = 2; */
        if (message.showToUser !== false)
            writer.tag(2, WireType.Varint).bool(message.showToUser);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.AdminProviderConfig
 */
export const AdminProviderConfig = new AdminProviderConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SharedProviderConfig$Type extends MessageType<SharedProviderConfig> {
    constructor() {
        super("c1.api.form.v1.SharedProviderConfig", [
            { no: 1, name: "default_value_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "lock_default_values", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "input_transformation_cel", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SharedProviderConfig>): SharedProviderConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.defaultValueCel = "";
        message.lockDefaultValues = false;
        message.inputTransformationCel = "";
        if (value !== undefined)
            reflectionMergePartial<SharedProviderConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SharedProviderConfig): SharedProviderConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string default_value_cel */ 1:
                    message.defaultValueCel = reader.string();
                    break;
                case /* bool lock_default_values */ 2:
                    message.lockDefaultValues = reader.bool();
                    break;
                case /* string input_transformation_cel */ 3:
                    message.inputTransformationCel = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SharedProviderConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string default_value_cel = 1; */
        if (message.defaultValueCel !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.defaultValueCel);
        /* bool lock_default_values = 2; */
        if (message.lockDefaultValues !== false)
            writer.tag(2, WireType.Varint).bool(message.lockDefaultValues);
        /* string input_transformation_cel = 3; */
        if (message.inputTransformationCel !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.inputTransformationCel);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.SharedProviderConfig
 */
export const SharedProviderConfig = new SharedProviderConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StringField$Type extends MessageType<StringField> {
    constructor() {
        super("c1.api.form.v1.StringField", [
            { no: 1, name: "default_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "rules", kind: "message", T: () => StringRules },
            { no: 3, name: "placeholder", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "text_field", kind: "message", oneof: "view", T: () => TextField },
            { no: 101, name: "password_field", kind: "message", oneof: "view", T: () => PasswordField },
            { no: 104, name: "select_field", kind: "message", oneof: "view", T: () => SelectField },
            { no: 103, name: "picker_field", kind: "message", oneof: "view", T: () => PickerField }
        ]);
    }
    create(value?: PartialMessage<StringField>): StringField {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.defaultValue = "";
        message.placeholder = "";
        message.view = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<StringField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StringField): StringField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string default_value */ 1:
                    message.defaultValue = reader.string();
                    break;
                case /* optional validate.StringRules rules */ 2:
                    message.rules = StringRules.internalBinaryRead(reader, reader.uint32(), options, message.rules);
                    break;
                case /* string placeholder */ 3:
                    message.placeholder = reader.string();
                    break;
                case /* c1.api.form.v1.TextField text_field */ 100:
                    message.view = {
                        oneofKind: "textField",
                        textField: TextField.internalBinaryRead(reader, reader.uint32(), options, (message.view as any).textField)
                    };
                    break;
                case /* c1.api.form.v1.PasswordField password_field */ 101:
                    message.view = {
                        oneofKind: "passwordField",
                        passwordField: PasswordField.internalBinaryRead(reader, reader.uint32(), options, (message.view as any).passwordField)
                    };
                    break;
                case /* c1.api.form.v1.SelectField select_field */ 104:
                    message.view = {
                        oneofKind: "selectField",
                        selectField: SelectField.internalBinaryRead(reader, reader.uint32(), options, (message.view as any).selectField)
                    };
                    break;
                case /* c1.api.form.v1.PickerField picker_field */ 103:
                    message.view = {
                        oneofKind: "pickerField",
                        pickerField: PickerField.internalBinaryRead(reader, reader.uint32(), options, (message.view as any).pickerField)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StringField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string default_value = 1; */
        if (message.defaultValue !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.defaultValue);
        /* optional validate.StringRules rules = 2; */
        if (message.rules)
            StringRules.internalBinaryWrite(message.rules, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string placeholder = 3; */
        if (message.placeholder !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.placeholder);
        /* c1.api.form.v1.TextField text_field = 100; */
        if (message.view.oneofKind === "textField")
            TextField.internalBinaryWrite(message.view.textField, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.form.v1.PasswordField password_field = 101; */
        if (message.view.oneofKind === "passwordField")
            PasswordField.internalBinaryWrite(message.view.passwordField, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.form.v1.PickerField picker_field = 103; */
        if (message.view.oneofKind === "pickerField")
            PickerField.internalBinaryWrite(message.view.pickerField, writer.tag(103, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.form.v1.SelectField select_field = 104; */
        if (message.view.oneofKind === "selectField")
            SelectField.internalBinaryWrite(message.view.selectField, writer.tag(104, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.StringField
 */
export const StringField = new StringField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TextField$Type extends MessageType<TextField> {
    constructor() {
        super("c1.api.form.v1.TextField", [
            { no: 1, name: "multiline", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<TextField>): TextField {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.multiline = false;
        if (value !== undefined)
            reflectionMergePartial<TextField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TextField): TextField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool multiline */ 1:
                    message.multiline = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TextField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool multiline = 1; */
        if (message.multiline !== false)
            writer.tag(1, WireType.Varint).bool(message.multiline);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.TextField
 */
export const TextField = new TextField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordField$Type extends MessageType<PasswordField> {
    constructor() {
        super("c1.api.form.v1.PasswordField", []);
    }
    create(value?: PartialMessage<PasswordField>): PasswordField {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<PasswordField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordField): PasswordField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.PasswordField
 */
export const PasswordField = new PasswordField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Oauth2Field$Type extends MessageType<Oauth2Field> {
    constructor() {
        super("c1.api.form.v1.Oauth2Field", [
            { no: 100, name: "oauth2_field_view", kind: "message", oneof: "view", T: () => Oauth2FieldView }
        ]);
    }
    create(value?: PartialMessage<Oauth2Field>): Oauth2Field {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.view = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<Oauth2Field>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Oauth2Field): Oauth2Field {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.form.v1.Oauth2FieldView oauth2_field_view */ 100:
                    message.view = {
                        oneofKind: "oauth2FieldView",
                        oauth2FieldView: Oauth2FieldView.internalBinaryRead(reader, reader.uint32(), options, (message.view as any).oauth2FieldView)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Oauth2Field, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.form.v1.Oauth2FieldView oauth2_field_view = 100; */
        if (message.view.oneofKind === "oauth2FieldView")
            Oauth2FieldView.internalBinaryWrite(message.view.oauth2FieldView, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.Oauth2Field
 */
export const Oauth2Field = new Oauth2Field$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Oauth2FieldView$Type extends MessageType<Oauth2FieldView> {
    constructor() {
        super("c1.api.form.v1.Oauth2FieldView", []);
    }
    create(value?: PartialMessage<Oauth2FieldView>): Oauth2FieldView {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Oauth2FieldView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Oauth2FieldView): Oauth2FieldView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Oauth2FieldView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.Oauth2FieldView
 */
export const Oauth2FieldView = new Oauth2FieldView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BoolField$Type extends MessageType<BoolField> {
    constructor() {
        super("c1.api.form.v1.BoolField", [
            { no: 1, name: "default_value", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "rules", kind: "message", T: () => BoolRules },
            { no: 100, name: "checkbox_field", kind: "message", oneof: "view", T: () => CheckboxField },
            { no: 101, name: "toggle_field", kind: "message", oneof: "view", T: () => ToggleField }
        ]);
    }
    create(value?: PartialMessage<BoolField>): BoolField {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.defaultValue = false;
        message.view = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<BoolField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BoolField): BoolField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool default_value */ 1:
                    message.defaultValue = reader.bool();
                    break;
                case /* optional validate.BoolRules rules */ 2:
                    message.rules = BoolRules.internalBinaryRead(reader, reader.uint32(), options, message.rules);
                    break;
                case /* c1.api.form.v1.CheckboxField checkbox_field */ 100:
                    message.view = {
                        oneofKind: "checkboxField",
                        checkboxField: CheckboxField.internalBinaryRead(reader, reader.uint32(), options, (message.view as any).checkboxField)
                    };
                    break;
                case /* c1.api.form.v1.ToggleField toggle_field */ 101:
                    message.view = {
                        oneofKind: "toggleField",
                        toggleField: ToggleField.internalBinaryRead(reader, reader.uint32(), options, (message.view as any).toggleField)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BoolField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool default_value = 1; */
        if (message.defaultValue !== false)
            writer.tag(1, WireType.Varint).bool(message.defaultValue);
        /* optional validate.BoolRules rules = 2; */
        if (message.rules)
            BoolRules.internalBinaryWrite(message.rules, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.form.v1.CheckboxField checkbox_field = 100; */
        if (message.view.oneofKind === "checkboxField")
            CheckboxField.internalBinaryWrite(message.view.checkboxField, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.form.v1.ToggleField toggle_field = 101; */
        if (message.view.oneofKind === "toggleField")
            ToggleField.internalBinaryWrite(message.view.toggleField, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.BoolField
 */
export const BoolField = new BoolField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckboxField$Type extends MessageType<CheckboxField> {
    constructor() {
        super("c1.api.form.v1.CheckboxField", []);
    }
    create(value?: PartialMessage<CheckboxField>): CheckboxField {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CheckboxField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CheckboxField): CheckboxField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CheckboxField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.CheckboxField
 */
export const CheckboxField = new CheckboxField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToggleField$Type extends MessageType<ToggleField> {
    constructor() {
        super("c1.api.form.v1.ToggleField", []);
    }
    create(value?: PartialMessage<ToggleField>): ToggleField {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ToggleField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToggleField): ToggleField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToggleField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.ToggleField
 */
export const ToggleField = new ToggleField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StringSliceField$Type extends MessageType<StringSliceField> {
    constructor() {
        super("c1.api.form.v1.StringSliceField", [
            { no: 1, name: "default_values", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "placeholder", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "rules", kind: "message", T: () => RepeatedRules },
            { no: 100, name: "chips_field", kind: "message", oneof: "view", T: () => ChipsField },
            { no: 102, name: "picker_field", kind: "message", oneof: "view", T: () => PickerField }
        ]);
    }
    create(value?: PartialMessage<StringSliceField>): StringSliceField {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.defaultValues = [];
        message.placeholder = "";
        message.view = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<StringSliceField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StringSliceField): StringSliceField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string default_values */ 1:
                    message.defaultValues.push(reader.string());
                    break;
                case /* string placeholder */ 3:
                    message.placeholder = reader.string();
                    break;
                case /* optional validate.RepeatedRules rules */ 4:
                    message.rules = RepeatedRules.internalBinaryRead(reader, reader.uint32(), options, message.rules);
                    break;
                case /* c1.api.form.v1.ChipsField chips_field */ 100:
                    message.view = {
                        oneofKind: "chipsField",
                        chipsField: ChipsField.internalBinaryRead(reader, reader.uint32(), options, (message.view as any).chipsField)
                    };
                    break;
                case /* c1.api.form.v1.PickerField picker_field */ 102:
                    message.view = {
                        oneofKind: "pickerField",
                        pickerField: PickerField.internalBinaryRead(reader, reader.uint32(), options, (message.view as any).pickerField)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StringSliceField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string default_values = 1; */
        for (let i = 0; i < message.defaultValues.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.defaultValues[i]);
        /* string placeholder = 3; */
        if (message.placeholder !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.placeholder);
        /* optional validate.RepeatedRules rules = 4; */
        if (message.rules)
            RepeatedRules.internalBinaryWrite(message.rules, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.form.v1.ChipsField chips_field = 100; */
        if (message.view.oneofKind === "chipsField")
            ChipsField.internalBinaryWrite(message.view.chipsField, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.form.v1.PickerField picker_field = 102; */
        if (message.view.oneofKind === "pickerField")
            PickerField.internalBinaryWrite(message.view.pickerField, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.StringSliceField
 */
export const StringSliceField = new StringSliceField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SelectField$Type extends MessageType<SelectField> {
    constructor() {
        super("c1.api.form.v1.SelectField", [
            { no: 2, name: "options", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SelectOption },
            { no: 3, name: "type", kind: "enum", T: () => ["c1.api.form.v1.SelectField.SelectType", SelectField_SelectType, "SELECT_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<SelectField>): SelectField {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.options = [];
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<SelectField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SelectField): SelectField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.form.v1.SelectOption options */ 2:
                    message.options.push(SelectOption.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* c1.api.form.v1.SelectField.SelectType type */ 3:
                    message.type = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SelectField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.form.v1.SelectOption options = 2; */
        for (let i = 0; i < message.options.length; i++)
            SelectOption.internalBinaryWrite(message.options[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.form.v1.SelectField.SelectType type = 3; */
        if (message.type !== 0)
            writer.tag(3, WireType.Varint).int32(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.SelectField
 */
export const SelectField = new SelectField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SelectOption$Type extends MessageType<SelectOption> {
    constructor() {
        super("c1.api.form.v1.SelectOption", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SelectOption>): SelectOption {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.displayName = "";
        message.value = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<SelectOption>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SelectOption): SelectOption {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string display_name */ 1:
                    message.displayName = reader.string();
                    break;
                case /* string value */ 2:
                    message.value = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SelectOption, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string display_name = 1; */
        if (message.displayName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.displayName);
        /* string value = 2; */
        if (message.value !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.value);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.SelectOption
 */
export const SelectOption = new SelectOption$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChipsField$Type extends MessageType<ChipsField> {
    constructor() {
        super("c1.api.form.v1.ChipsField", []);
    }
    create(value?: PartialMessage<ChipsField>): ChipsField {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ChipsField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ChipsField): ChipsField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ChipsField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.ChipsField
 */
export const ChipsField = new ChipsField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PickerField$Type extends MessageType<PickerField> {
    constructor() {
        super("c1.api.form.v1.PickerField", [
            { no: 100, name: "app_user_picker", kind: "message", oneof: "type", T: () => AppUserFilter },
            { no: 101, name: "resource_picker", kind: "message", oneof: "type", T: () => AppResourceFilter },
            { no: 102, name: "c1_user_picker", kind: "message", oneof: "type", T: () => C1UserFilter }
        ]);
    }
    create(value?: PartialMessage<PickerField>): PickerField {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<PickerField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PickerField): PickerField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.form.v1.AppUserFilter app_user_picker */ 100:
                    message.type = {
                        oneofKind: "appUserPicker",
                        appUserPicker: AppUserFilter.internalBinaryRead(reader, reader.uint32(), options, (message.type as any).appUserPicker)
                    };
                    break;
                case /* c1.api.form.v1.AppResourceFilter resource_picker */ 101:
                    message.type = {
                        oneofKind: "resourcePicker",
                        resourcePicker: AppResourceFilter.internalBinaryRead(reader, reader.uint32(), options, (message.type as any).resourcePicker)
                    };
                    break;
                case /* c1.api.form.v1.C1UserFilter c1_user_picker */ 102:
                    message.type = {
                        oneofKind: "c1UserPicker",
                        c1UserPicker: C1UserFilter.internalBinaryRead(reader, reader.uint32(), options, (message.type as any).c1UserPicker)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PickerField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.form.v1.AppUserFilter app_user_picker = 100; */
        if (message.type.oneofKind === "appUserPicker")
            AppUserFilter.internalBinaryWrite(message.type.appUserPicker, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.form.v1.AppResourceFilter resource_picker = 101; */
        if (message.type.oneofKind === "resourcePicker")
            AppResourceFilter.internalBinaryWrite(message.type.resourcePicker, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.form.v1.C1UserFilter c1_user_picker = 102; */
        if (message.type.oneofKind === "c1UserPicker")
            C1UserFilter.internalBinaryWrite(message.type.c1UserPicker, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.PickerField
 */
export const PickerField = new PickerField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserFilter$Type extends MessageType<AppUserFilter> {
    constructor() {
        super("c1.api.form.v1.AppUserFilter", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppUserFilter>): AppUserFilter {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<AppUserFilter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserFilter): AppUserFilter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserFilter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.AppUserFilter
 */
export const AppUserFilter = new AppUserFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceFilter$Type extends MessageType<AppResourceFilter> {
    constructor() {
        super("c1.api.form.v1.AppResourceFilter", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppResourceFilter>): AppResourceFilter {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.resourceTypeId = "";
        if (value !== undefined)
            reflectionMergePartial<AppResourceFilter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppResourceFilter): AppResourceFilter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string resource_type_id */ 2:
                    message.resourceTypeId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppResourceFilter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string resource_type_id = 2; */
        if (message.resourceTypeId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.resourceTypeId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.AppResourceFilter
 */
export const AppResourceFilter = new AppResourceFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class C1UserFilter$Type extends MessageType<C1UserFilter> {
    constructor() {
        super("c1.api.form.v1.C1UserFilter", []);
    }
    create(value?: PartialMessage<C1UserFilter>): C1UserFilter {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<C1UserFilter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: C1UserFilter): C1UserFilter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: C1UserFilter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.C1UserFilter
 */
export const C1UserFilter = new C1UserFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Int64Field$Type extends MessageType<Int64Field> {
    constructor() {
        super("c1.api.form.v1.Int64Field", [
            { no: 1, name: "default_value", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "rules", kind: "message", T: () => Int64Rules },
            { no: 3, name: "placeholder", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "number_field", kind: "message", oneof: "view", T: () => NumberField }
        ]);
    }
    create(value?: PartialMessage<Int64Field>): Int64Field {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.placeholder = "";
        message.view = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<Int64Field>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Int64Field): Int64Field {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional int64 default_value */ 1:
                    message.defaultValue = reader.int64().toNumber();
                    break;
                case /* optional validate.Int64Rules rules */ 2:
                    message.rules = Int64Rules.internalBinaryRead(reader, reader.uint32(), options, message.rules);
                    break;
                case /* string placeholder */ 3:
                    message.placeholder = reader.string();
                    break;
                case /* c1.api.form.v1.NumberField number_field */ 100:
                    message.view = {
                        oneofKind: "numberField",
                        numberField: NumberField.internalBinaryRead(reader, reader.uint32(), options, (message.view as any).numberField)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Int64Field, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional int64 default_value = 1; */
        if (message.defaultValue !== undefined)
            writer.tag(1, WireType.Varint).int64(message.defaultValue);
        /* optional validate.Int64Rules rules = 2; */
        if (message.rules)
            Int64Rules.internalBinaryWrite(message.rules, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string placeholder = 3; */
        if (message.placeholder !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.placeholder);
        /* c1.api.form.v1.NumberField number_field = 100; */
        if (message.view.oneofKind === "numberField")
            NumberField.internalBinaryWrite(message.view.numberField, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.Int64Field
 */
export const Int64Field = new Int64Field$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NumberField$Type extends MessageType<NumberField> {
    constructor() {
        super("c1.api.form.v1.NumberField", [
            { no: 1, name: "min_value", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "max_value", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "step", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<NumberField>): NumberField {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.minValue = 0;
        message.maxValue = 0;
        message.step = 0;
        if (value !== undefined)
            reflectionMergePartial<NumberField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NumberField): NumberField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 min_value */ 1:
                    message.minValue = reader.int64().toNumber();
                    break;
                case /* int64 max_value */ 2:
                    message.maxValue = reader.int64().toNumber();
                    break;
                case /* int64 step */ 3:
                    message.step = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NumberField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 min_value = 1; */
        if (message.minValue !== 0)
            writer.tag(1, WireType.Varint).int64(message.minValue);
        /* int64 max_value = 2; */
        if (message.maxValue !== 0)
            writer.tag(2, WireType.Varint).int64(message.maxValue);
        /* int64 step = 3; */
        if (message.step !== 0)
            writer.tag(3, WireType.Varint).int64(message.step);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.NumberField
 */
export const NumberField = new NumberField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FileField$Type extends MessageType<FileField> {
    constructor() {
        super("c1.api.form.v1.FileField", [
            { no: 1, name: "accepted_file_types", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "max_file_size", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 100, name: "file_input_field", kind: "message", oneof: "view", T: () => FileInputField }
        ]);
    }
    create(value?: PartialMessage<FileField>): FileField {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.acceptedFileTypes = [];
        message.view = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<FileField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FileField): FileField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string accepted_file_types */ 1:
                    message.acceptedFileTypes.push(reader.string());
                    break;
                case /* optional int64 max_file_size */ 2:
                    message.maxFileSize = reader.int64().toNumber();
                    break;
                case /* c1.api.form.v1.FileInputField file_input_field */ 100:
                    message.view = {
                        oneofKind: "fileInputField",
                        fileInputField: FileInputField.internalBinaryRead(reader, reader.uint32(), options, (message.view as any).fileInputField)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FileField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string accepted_file_types = 1; */
        for (let i = 0; i < message.acceptedFileTypes.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.acceptedFileTypes[i]);
        /* optional int64 max_file_size = 2; */
        if (message.maxFileSize !== undefined)
            writer.tag(2, WireType.Varint).int64(message.maxFileSize);
        /* c1.api.form.v1.FileInputField file_input_field = 100; */
        if (message.view.oneofKind === "fileInputField")
            FileInputField.internalBinaryWrite(message.view.fileInputField, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FileField
 */
export const FileField = new FileField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FileInputField$Type extends MessageType<FileInputField> {
    constructor() {
        super("c1.api.form.v1.FileInputField", []);
    }
    create(value?: PartialMessage<FileInputField>): FileInputField {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<FileInputField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FileInputField): FileInputField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FileInputField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FileInputField
 */
export const FileInputField = new FileInputField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FieldRelationship$Type extends MessageType<FieldRelationship> {
    constructor() {
        super("c1.api.form.v1.FieldRelationship", [
            { no: 1, name: "field_names", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "required_together", kind: "message", oneof: "kind", T: () => RequiredTogether },
            { no: 101, name: "at_least_one", kind: "message", oneof: "kind", T: () => AtLeastOne },
            { no: 102, name: "mutually_exclusive", kind: "message", oneof: "kind", T: () => MutuallyExclusive },
            { no: 103, name: "dependent_on", kind: "message", oneof: "kind", T: () => DependentOn }
        ]);
    }
    create(value?: PartialMessage<FieldRelationship>): FieldRelationship {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fieldNames = [];
        message.kind = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<FieldRelationship>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FieldRelationship): FieldRelationship {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string field_names */ 1:
                    message.fieldNames.push(reader.string());
                    break;
                case /* c1.api.form.v1.RequiredTogether required_together */ 100:
                    message.kind = {
                        oneofKind: "requiredTogether",
                        requiredTogether: RequiredTogether.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).requiredTogether)
                    };
                    break;
                case /* c1.api.form.v1.AtLeastOne at_least_one */ 101:
                    message.kind = {
                        oneofKind: "atLeastOne",
                        atLeastOne: AtLeastOne.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).atLeastOne)
                    };
                    break;
                case /* c1.api.form.v1.MutuallyExclusive mutually_exclusive */ 102:
                    message.kind = {
                        oneofKind: "mutuallyExclusive",
                        mutuallyExclusive: MutuallyExclusive.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).mutuallyExclusive)
                    };
                    break;
                case /* c1.api.form.v1.DependentOn dependent_on */ 103:
                    message.kind = {
                        oneofKind: "dependentOn",
                        dependentOn: DependentOn.internalBinaryRead(reader, reader.uint32(), options, (message.kind as any).dependentOn)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FieldRelationship, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string field_names = 1; */
        for (let i = 0; i < message.fieldNames.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.fieldNames[i]);
        /* c1.api.form.v1.RequiredTogether required_together = 100; */
        if (message.kind.oneofKind === "requiredTogether")
            RequiredTogether.internalBinaryWrite(message.kind.requiredTogether, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.form.v1.AtLeastOne at_least_one = 101; */
        if (message.kind.oneofKind === "atLeastOne")
            AtLeastOne.internalBinaryWrite(message.kind.atLeastOne, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.form.v1.MutuallyExclusive mutually_exclusive = 102; */
        if (message.kind.oneofKind === "mutuallyExclusive")
            MutuallyExclusive.internalBinaryWrite(message.kind.mutuallyExclusive, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.form.v1.DependentOn dependent_on = 103; */
        if (message.kind.oneofKind === "dependentOn")
            DependentOn.internalBinaryWrite(message.kind.dependentOn, writer.tag(103, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FieldRelationship
 */
export const FieldRelationship = new FieldRelationship$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequiredTogether$Type extends MessageType<RequiredTogether> {
    constructor() {
        super("c1.api.form.v1.RequiredTogether", []);
    }
    create(value?: PartialMessage<RequiredTogether>): RequiredTogether {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RequiredTogether>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequiredTogether): RequiredTogether {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequiredTogether, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.RequiredTogether
 */
export const RequiredTogether = new RequiredTogether$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AtLeastOne$Type extends MessageType<AtLeastOne> {
    constructor() {
        super("c1.api.form.v1.AtLeastOne", []);
    }
    create(value?: PartialMessage<AtLeastOne>): AtLeastOne {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AtLeastOne>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AtLeastOne): AtLeastOne {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AtLeastOne, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.AtLeastOne
 */
export const AtLeastOne = new AtLeastOne$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MutuallyExclusive$Type extends MessageType<MutuallyExclusive> {
    constructor() {
        super("c1.api.form.v1.MutuallyExclusive", []);
    }
    create(value?: PartialMessage<MutuallyExclusive>): MutuallyExclusive {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<MutuallyExclusive>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MutuallyExclusive): MutuallyExclusive {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MutuallyExclusive, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.MutuallyExclusive
 */
export const MutuallyExclusive = new MutuallyExclusive$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DependentOn$Type extends MessageType<DependentOn> {
    constructor() {
        super("c1.api.form.v1.DependentOn", [
            { no: 1, name: "dependency_field_names", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DependentOn>): DependentOn {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.dependencyFieldNames = [];
        if (value !== undefined)
            reflectionMergePartial<DependentOn>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DependentOn): DependentOn {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string dependency_field_names */ 1:
                    message.dependencyFieldNames.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DependentOn, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string dependency_field_names = 1; */
        for (let i = 0; i < message.dependencyFieldNames.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.dependencyFieldNames[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.DependentOn
 */
export const DependentOn = new DependentOn$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FieldGroup$Type extends MessageType<FieldGroup> {
    constructor() {
        super("c1.api.form.v1.FieldGroup", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "help_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "fields", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "default", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<FieldGroup>): FieldGroup {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.displayName = "";
        message.helpText = "";
        message.fields = [];
        message.default = false;
        if (value !== undefined)
            reflectionMergePartial<FieldGroup>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FieldGroup): FieldGroup {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* string help_text */ 3:
                    message.helpText = reader.string();
                    break;
                case /* repeated string fields */ 4:
                    message.fields.push(reader.string());
                    break;
                case /* bool default */ 5:
                    message.default = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FieldGroup, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* string help_text = 3; */
        if (message.helpText !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.helpText);
        /* repeated string fields = 4; */
        for (let i = 0; i < message.fields.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.fields[i]);
        /* bool default = 5; */
        if (message.default !== false)
            writer.tag(5, WireType.Varint).bool(message.default);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FieldGroup
 */
export const FieldGroup = new FieldGroup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSchema$Type extends MessageType<FormSchema> {
    constructor() {
        super("c1.api.form.v1.FormSchema", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "form", kind: "message", T: () => Form },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "usage_context", kind: "enum", T: () => ["c1.api.form.v1.FormSchemaUsageContext", FormSchemaUsageContext, "FORM_SCHEMA_USAGE_CONTEXT_"], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<FormSchema>): FormSchema {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        message.usageContext = 0;
        if (value !== undefined)
            reflectionMergePartial<FormSchema>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FormSchema): FormSchema {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* c1.api.form.v1.Form form */ 3:
                    message.form = Form.internalBinaryRead(reader, reader.uint32(), options, message.form);
                    break;
                case /* google.protobuf.Timestamp created_at */ 4:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 5:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 6:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* c1.api.form.v1.FormSchemaUsageContext usage_context */ 7:
                    message.usageContext = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FormSchema, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* c1.api.form.v1.Form form = 3; */
        if (message.form)
            Form.internalBinaryWrite(message.form, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 4; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 5; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 6; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.form.v1.FormSchemaUsageContext usage_context = 7; */
        if (message.usageContext !== 0)
            writer.tag(7, WireType.Varint).int32(message.usageContext);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FormSchema
 */
export const FormSchema = new FormSchema$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSchemaRef$Type extends MessageType<FormSchemaRef> {
    constructor() {
        super("c1.api.form.v1.FormSchemaRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<FormSchemaRef>): FormSchemaRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<FormSchemaRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FormSchemaRef): FormSchemaRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FormSchemaRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FormSchemaRef
 */
export const FormSchemaRef = new FormSchemaRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSchemaServiceCreateRequest$Type extends MessageType<FormSchemaServiceCreateRequest> {
    constructor() {
        super("c1.api.form.v1.FormSchemaServiceCreateRequest", [
            { no: 1, name: "form", kind: "message", T: () => Form, options: { "validate.rules": { message: { required: true } } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "usage_context", kind: "enum", T: () => ["c1.api.form.v1.FormSchemaUsageContext", FormSchemaUsageContext, "FORM_SCHEMA_USAGE_CONTEXT_"] }
        ]);
    }
    create(value?: PartialMessage<FormSchemaServiceCreateRequest>): FormSchemaServiceCreateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.displayName = "";
        message.usageContext = 0;
        if (value !== undefined)
            reflectionMergePartial<FormSchemaServiceCreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FormSchemaServiceCreateRequest): FormSchemaServiceCreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.form.v1.Form form */ 1:
                    message.form = Form.internalBinaryRead(reader, reader.uint32(), options, message.form);
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* c1.api.form.v1.FormSchemaUsageContext usage_context */ 3:
                    message.usageContext = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FormSchemaServiceCreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.form.v1.Form form = 1; */
        if (message.form)
            Form.internalBinaryWrite(message.form, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* c1.api.form.v1.FormSchemaUsageContext usage_context = 3; */
        if (message.usageContext !== 0)
            writer.tag(3, WireType.Varint).int32(message.usageContext);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FormSchemaServiceCreateRequest
 */
export const FormSchemaServiceCreateRequest = new FormSchemaServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSchemaServiceCreateResponse$Type extends MessageType<FormSchemaServiceCreateResponse> {
    constructor() {
        super("c1.api.form.v1.FormSchemaServiceCreateResponse", [
            { no: 1, name: "form_schema", kind: "message", T: () => FormSchema }
        ]);
    }
    create(value?: PartialMessage<FormSchemaServiceCreateResponse>): FormSchemaServiceCreateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<FormSchemaServiceCreateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FormSchemaServiceCreateResponse): FormSchemaServiceCreateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.form.v1.FormSchema form_schema */ 1:
                    message.formSchema = FormSchema.internalBinaryRead(reader, reader.uint32(), options, message.formSchema);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FormSchemaServiceCreateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.form.v1.FormSchema form_schema = 1; */
        if (message.formSchema)
            FormSchema.internalBinaryWrite(message.formSchema, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FormSchemaServiceCreateResponse
 */
export const FormSchemaServiceCreateResponse = new FormSchemaServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSchemaServiceGetRequest$Type extends MessageType<FormSchemaServiceGetRequest> {
    constructor() {
        super("c1.api.form.v1.FormSchemaServiceGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<FormSchemaServiceGetRequest>): FormSchemaServiceGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<FormSchemaServiceGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FormSchemaServiceGetRequest): FormSchemaServiceGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FormSchemaServiceGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FormSchemaServiceGetRequest
 */
export const FormSchemaServiceGetRequest = new FormSchemaServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSchemaServiceGetResponse$Type extends MessageType<FormSchemaServiceGetResponse> {
    constructor() {
        super("c1.api.form.v1.FormSchemaServiceGetResponse", [
            { no: 1, name: "form_schema", kind: "message", T: () => FormSchema }
        ]);
    }
    create(value?: PartialMessage<FormSchemaServiceGetResponse>): FormSchemaServiceGetResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<FormSchemaServiceGetResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FormSchemaServiceGetResponse): FormSchemaServiceGetResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.form.v1.FormSchema form_schema */ 1:
                    message.formSchema = FormSchema.internalBinaryRead(reader, reader.uint32(), options, message.formSchema);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FormSchemaServiceGetResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.form.v1.FormSchema form_schema = 1; */
        if (message.formSchema)
            FormSchema.internalBinaryWrite(message.formSchema, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FormSchemaServiceGetResponse
 */
export const FormSchemaServiceGetResponse = new FormSchemaServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSchemaServiceListRequest$Type extends MessageType<FormSchemaServiceListRequest> {
    constructor() {
        super("c1.api.form.v1.FormSchemaServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FormSchemaRef }
        ]);
    }
    create(value?: PartialMessage<FormSchemaServiceListRequest>): FormSchemaServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<FormSchemaServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FormSchemaServiceListRequest): FormSchemaServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* repeated c1.api.form.v1.FormSchemaRef refs */ 3:
                    message.refs.push(FormSchemaRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FormSchemaServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* repeated c1.api.form.v1.FormSchemaRef refs = 3; */
        for (let i = 0; i < message.refs.length; i++)
            FormSchemaRef.internalBinaryWrite(message.refs[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FormSchemaServiceListRequest
 */
export const FormSchemaServiceListRequest = new FormSchemaServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSchemaServiceListResponse$Type extends MessageType<FormSchemaServiceListResponse> {
    constructor() {
        super("c1.api.form.v1.FormSchemaServiceListResponse", [
            { no: 1, name: "form_schemas", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FormSchema },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FormSchemaServiceListResponse>): FormSchemaServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.formSchemas = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<FormSchemaServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FormSchemaServiceListResponse): FormSchemaServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.form.v1.FormSchema form_schemas */ 1:
                    message.formSchemas.push(FormSchema.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FormSchemaServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.form.v1.FormSchema form_schemas = 1; */
        for (let i = 0; i < message.formSchemas.length; i++)
            FormSchema.internalBinaryWrite(message.formSchemas[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FormSchemaServiceListResponse
 */
export const FormSchemaServiceListResponse = new FormSchemaServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSchemaServiceUpdateRequest$Type extends MessageType<FormSchemaServiceUpdateRequest> {
    constructor() {
        super("c1.api.form.v1.FormSchemaServiceUpdateRequest", [
            { no: 1, name: "form_schema", kind: "message", T: () => FormSchema, options: { "validate.rules": { message: { required: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value?: PartialMessage<FormSchemaServiceUpdateRequest>): FormSchemaServiceUpdateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<FormSchemaServiceUpdateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FormSchemaServiceUpdateRequest): FormSchemaServiceUpdateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.form.v1.FormSchema form_schema */ 1:
                    message.formSchema = FormSchema.internalBinaryRead(reader, reader.uint32(), options, message.formSchema);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FormSchemaServiceUpdateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.form.v1.FormSchema form_schema = 1; */
        if (message.formSchema)
            FormSchema.internalBinaryWrite(message.formSchema, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FormSchemaServiceUpdateRequest
 */
export const FormSchemaServiceUpdateRequest = new FormSchemaServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSchemaServiceUpdateResponse$Type extends MessageType<FormSchemaServiceUpdateResponse> {
    constructor() {
        super("c1.api.form.v1.FormSchemaServiceUpdateResponse", [
            { no: 1, name: "form_schema", kind: "message", T: () => FormSchema }
        ]);
    }
    create(value?: PartialMessage<FormSchemaServiceUpdateResponse>): FormSchemaServiceUpdateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<FormSchemaServiceUpdateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FormSchemaServiceUpdateResponse): FormSchemaServiceUpdateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.form.v1.FormSchema form_schema */ 1:
                    message.formSchema = FormSchema.internalBinaryRead(reader, reader.uint32(), options, message.formSchema);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FormSchemaServiceUpdateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.form.v1.FormSchema form_schema = 1; */
        if (message.formSchema)
            FormSchema.internalBinaryWrite(message.formSchema, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FormSchemaServiceUpdateResponse
 */
export const FormSchemaServiceUpdateResponse = new FormSchemaServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSchemaServiceDeleteRequest$Type extends MessageType<FormSchemaServiceDeleteRequest> {
    constructor() {
        super("c1.api.form.v1.FormSchemaServiceDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<FormSchemaServiceDeleteRequest>): FormSchemaServiceDeleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<FormSchemaServiceDeleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FormSchemaServiceDeleteRequest): FormSchemaServiceDeleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FormSchemaServiceDeleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FormSchemaServiceDeleteRequest
 */
export const FormSchemaServiceDeleteRequest = new FormSchemaServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSchemaServiceDeleteResponse$Type extends MessageType<FormSchemaServiceDeleteResponse> {
    constructor() {
        super("c1.api.form.v1.FormSchemaServiceDeleteResponse", []);
    }
    create(value?: PartialMessage<FormSchemaServiceDeleteResponse>): FormSchemaServiceDeleteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<FormSchemaServiceDeleteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FormSchemaServiceDeleteResponse): FormSchemaServiceDeleteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FormSchemaServiceDeleteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FormSchemaServiceDeleteResponse
 */
export const FormSchemaServiceDeleteResponse = new FormSchemaServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSchemaServiceSearchRequest$Type extends MessageType<FormSchemaServiceSearchRequest> {
    constructor() {
        super("c1.api.form.v1.FormSchemaServiceSearchRequest", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "usage_contexts", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.form.v1.FormSchemaUsageContext", FormSchemaUsageContext, "FORM_SCHEMA_USAGE_CONTEXT_"] }
        ]);
    }
    create(value?: PartialMessage<FormSchemaServiceSearchRequest>): FormSchemaServiceSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.usageContexts = [];
        if (value !== undefined)
            reflectionMergePartial<FormSchemaServiceSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FormSchemaServiceSearchRequest): FormSchemaServiceSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* repeated c1.api.form.v1.FormSchemaUsageContext usage_contexts */ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.usageContexts.push(reader.int32());
                    else
                        message.usageContexts.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FormSchemaServiceSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* repeated c1.api.form.v1.FormSchemaUsageContext usage_contexts = 4; */
        if (message.usageContexts.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.usageContexts.length; i++)
                writer.int32(message.usageContexts[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FormSchemaServiceSearchRequest
 */
export const FormSchemaServiceSearchRequest = new FormSchemaServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSchemaServiceSearchResponse$Type extends MessageType<FormSchemaServiceSearchResponse> {
    constructor() {
        super("c1.api.form.v1.FormSchemaServiceSearchResponse", [
            { no: 1, name: "form_schemas", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FormSchema },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FormSchema }
        ]);
    }
    create(value?: PartialMessage<FormSchemaServiceSearchResponse>): FormSchemaServiceSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.formSchemas = [];
        message.nextPageToken = "";
        message.list = [];
        if (value !== undefined)
            reflectionMergePartial<FormSchemaServiceSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FormSchemaServiceSearchResponse): FormSchemaServiceSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.form.v1.FormSchema form_schemas = 1 [deprecated = true] */ 1:
                    message.formSchemas.push(FormSchema.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated c1.api.form.v1.FormSchema list */ 3:
                    message.list.push(FormSchema.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FormSchemaServiceSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.form.v1.FormSchema form_schemas = 1 [deprecated = true]; */
        for (let i = 0; i < message.formSchemas.length; i++)
            FormSchema.internalBinaryWrite(message.formSchemas[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated c1.api.form.v1.FormSchema list = 3; */
        for (let i = 0; i < message.list.length; i++)
            FormSchema.internalBinaryWrite(message.list[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.form.v1.FormSchemaServiceSearchResponse
 */
export const FormSchemaServiceSearchResponse = new FormSchemaServiceSearchResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.form.v1.FormSchemaService
 */
export const FormSchemaService = new ServiceType("c1.api.form.v1.FormSchemaService", [
    { name: "Create", options: { "authz.method": { role: "EDITOR" } }, I: FormSchemaServiceCreateRequest, O: FormSchemaServiceCreateResponse },
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: FormSchemaServiceGetRequest, O: FormSchemaServiceGetResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: FormSchemaServiceListRequest, O: FormSchemaServiceListResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" } }, I: FormSchemaServiceUpdateRequest, O: FormSchemaServiceUpdateResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" } }, I: FormSchemaServiceDeleteRequest, O: FormSchemaServiceDeleteResponse },
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: FormSchemaServiceSearchRequest, O: FormSchemaServiceSearchResponse }
]);
